import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Avatar,
  Grid,
  Box,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

const Profile = () => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    phone: "",
    profilePicture: "",
    registration: "",
  });
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  // Buscar dados do usuário no backend
  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const response = await axios.get("https://codefort.onrender.com/api/profile", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setUserData(response.data); // Define os dados do usuário retornados pelo backend
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Aqui vamos enviar os dados para o backend
      if (file) {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Perfil do Usuário
        </Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              {/* Nome - Somente leitura */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Nome"
                  name="name"
                  value={userData.name}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              {/* E-mail - Somente leitura */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="E-mail"
                  name="email"
                  type="email"
                  value={userData.email}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              {/* Matrícula - Somente leitura */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Matrícula"
                  name="registration"
                  value={userData.registration}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              {/* Telefone - Editável */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Telefone"
                  name="phone"
                  value={userData.phone}
                  onChange={handleInputChange}
                  fullWidth
                />
              </Grid>
              {/* Foto de perfil */}
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    src={userData.profilePicture}
                    alt={userData.name}
                    sx={{ width: 80, height: 80 }}
                  />
                  <Button variant="contained" component="label">
                    Upload Foto
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </Button>
                </Box>
              </Grid>
              {/* Botão Salvar */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Salvar Alterações
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Box>
    </Container>
  );
};

export default Profile;
